export const APP_TOKEN = 'token-nosetea-cms';

export const URL = {
  login: `${process.env.REACT_APP_BASE_URL}/api/admin/loginwithuser`,
  getInfo: `${process.env.REACT_APP_BASE_URL}/api/admin/getinfo`,
  list: `${process.env.REACT_APP_BASE_URL}/api/cms/manage/slideshow/list`,
  add: `${process.env.REACT_APP_BASE_URL}/api/cms/manage/slideshow/add`,
  edit: `${process.env.REACT_APP_BASE_URL}/api/cms/manage/slideshow/edit`,
  delete: `${process.env.REACT_APP_BASE_URL}/api/cms/manage/slideshow/delete`,
}

export function setDataInfo(info) {
  localStorage.setItem(APP_TOKEN, JSON.stringify(info));
} 

export function getDataInfo() {
  const data = localStorage.getItem(APP_TOKEN);
  if (!data) return null; 
  return JSON.parse(data);
}

export function getRequestAccess() {
  return {
    access: isMobile() ? "mobile" : "web",
    appversion: process.env.REACT_APP_VISION,
    os: (navigator.appVersion || '').split(" ")?.[0] || '-',
    device: detectOS(),
    deviceid: uuidv4(),
    lat: "",
    long: ""
  }
}

function isMobile() {
  const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return regex.test(navigator.userAgent);
}

function detectOS() {
	let userAgent = navigator.userAgent,
		platform = navigator.platform,
		macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
		windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
		iosPlatforms = ['iPhone', 'iPad', 'iPod'],
		os = null;

	if (macosPlatforms.indexOf(platform) !== -1) {
		os = 'Mac OS';
	} else if (iosPlatforms.indexOf(platform) !== -1) {
		os = 'IOS';
	} else if (windowsPlatforms.indexOf(platform) !== -1) {
		os = 'Windows';
	} else if (/Android/.test(userAgent)) {
		os = 'Android';
	} else if (!os && /Linux/.test(platform)) {
		os = 'Linux';
	}
	return os;
}

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
  .replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0, 
          v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
  });
}

export function getDateFormat(date) {
  if (!date) return ''
  const split = date.split(' ');
  const sd = split[0].split('-'); 
  const st = split[1].split(':');
  return `${sd[2]}/${sd[1]}/${sd[0]} ${st[0]}:${st[1]}`;
}